import { memo } from "react";

import CalendarIcon from "@/components/ui/icon/calendar";
import HotelIcon from "@/components/ui/icon/hotel";
import PersonIcon from "@/components/ui/icon/person";
import RestaurantIcon from "@/components/ui/icon/restaurant";

import { Item } from "./item";

type Props = {
	primaryColor: string;
};

export const LikeReservationComponentInline = memo(({ primaryColor }: Props) => {
	return (
		<div className="w-full space-y-2">
			<div className="rounded-lg bg-white">
				<div>
					<Item label="プラン" title="未選択(任意)" iconChildren={<RestaurantIcon />} />

					<Item label="人数" title="１部屋２名" isSelected iconChildren={<PersonIcon />} />

					<Item label="日付" title="2025年04月01日 ~ 04月02日" isSelected iconChildren={<CalendarIcon />} />

					<Item label="部屋" title="ダブルルーム" isSelected iconChildren={<HotelIcon />} />
				</div>

				<div className="border-black flex items-center justify-between border-t-2 px-3">
					<div className="py-2.5">
						<p className="text-xs font-medium">合計金額</p>

						<div className="flex items-center gap-1.5">
							<p className="text-2xl font-medium">¥ 20,000</p>
							<span className="rounded border border-zinc-950 px-1 pb-0.5 text-xs text-black">内訳</span>
						</div>
					</div>

					<div className="rounded-lg" style={{ background: primaryColor }}>
						<p className="px-4 py-3 text-sm font-semibold text-white">予約を進める</p>
					</div>
				</div>
			</div>
		</div>
	);
});
